"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEmbeddedWorkflow = exports.CreateEmbeddedWorkflow = exports.CreateEmbeddedWorkflowActionTypes = exports.loadEcommerceWorkflowIds = exports.FetchEcommerceWorkflowIds = exports.FetchEcommerceWorkflowIdsActionTypes = exports.EcommerceWorkflowsActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("settings-ui-lib/utils/actions");

var _createAction = _interopRequireDefault(require("flux-actions/createAction"));

var EcommerceWorkflowsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_WORKFLOW_IDS: null,
  CREATE_EMBEDDED_WORKFLOW: null
}, 'ecommerce-workflows'); // == Embedded workflows ======================================================

exports.EcommerceWorkflowsActionTypes = EcommerceWorkflowsActionTypes;
var FetchEcommerceWorkflowIdsActionTypes = (0, _actions.createRequestTypes)(EcommerceWorkflowsActionTypes.FETCH_WORKFLOW_IDS);
exports.FetchEcommerceWorkflowIdsActionTypes = FetchEcommerceWorkflowIdsActionTypes;
var FetchEcommerceWorkflowIds = (0, _actions.createRequestActions)(FetchEcommerceWorkflowIdsActionTypes);
exports.FetchEcommerceWorkflowIds = FetchEcommerceWorkflowIds;
var loadEcommerceWorkflowIds = (0, _createAction.default)(EcommerceWorkflowsActionTypes.FETCH_WORKFLOW_IDS);
exports.loadEcommerceWorkflowIds = loadEcommerceWorkflowIds;
var CreateEmbeddedWorkflowActionTypes = (0, _actions.createRequestTypes)(EcommerceWorkflowsActionTypes.CREATE_EMBEDDED_WORKFLOW);
exports.CreateEmbeddedWorkflowActionTypes = CreateEmbeddedWorkflowActionTypes;
var CreateEmbeddedWorkflow = (0, _actions.createRequestActions)(CreateEmbeddedWorkflowActionTypes, {
  successPayloadCreator: function successPayloadCreator(response, props) {
    return {
      data: response,
      props: props
    };
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateEmbeddedWorkflow.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('ecommerce.dashboard.automation.createWorkflow.failure')));
  }
});
exports.CreateEmbeddedWorkflow = CreateEmbeddedWorkflow;
var createEmbeddedWorkflow = (0, _createAction.default)(EcommerceWorkflowsActionTypes.CREATE_EMBEDDED_WORKFLOW, (0, _actions.mapPayloadTo)('data'));
exports.createEmbeddedWorkflow = createEmbeddedWorkflow;